const PngFiles = {
    LogoEA : "/img/logos/LogoEA.png",
    LogoE : "/img/logos/LogoE.png",
    LogoA : "/img/logos/LogoA.png",
}


export default PngFiles;